import { useEffect, useLayoutEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import PATHS from 'constants/paths';
import useCreateAffordaPortalDetailsMutation from 'hooks/mutations/useCreateAffordaPortalDetailsMutation';
import useAffordaPortalDetailsQuery from 'hooks/queries/useAffordaPortalDetailsQuery';
import useBaseURL from 'hooks/useBaseURL';
import useShouldRedirectToWelcomeFlow from 'hooks/useShouldRedirectToWelcomeFlow';
import { useIsStudentDisqualified } from 'pages/AffordaHousehold/AffordaHousehold.FullTimeStudent.hooks';

const useAffordaPortal = ({ url }) => {
  const {
    push: historyPush,
    location: { pathname },
  } = useHistory();

  const baseURL = useBaseURL();
  const scrollRef = useRef(null);

  const { isLoading, shouldRedirectToWelcomeFlow } =
    useShouldRedirectToWelcomeFlow();
  const isStudentDisqualified = useIsStudentDisqualified();

  useLayoutEffect(() => {
    if (!scrollRef.current) {
      scrollRef.current = document.getElementById('scrollContainer');
    }
  });

  const {
    data: affordaPortalDetails,
    isLoading: isAffordaPortalDetailsLoading,
  } = useAffordaPortalDetailsQuery();
  const { mutate: createAffordaPortalDetailsMutate } =
    useCreateAffordaPortalDetailsMutation();

  useEffect(() => {
    // If the query is not loading and there is no data, create the afforda portal details
    if (!affordaPortalDetails && !isAffordaPortalDetailsLoading) {
      createAffordaPortalDetailsMutate();
    }
  }, [
    affordaPortalDetails,
    isAffordaPortalDetailsLoading,
    createAffordaPortalDetailsMutate,
  ]);

  const showGradient = [
    `${url}/${PATHS.WELCOME}`,
    `${url}/${PATHS.DASHBOARD}`,
    `${url}/${PATHS.APPLICATION}`,
    `${url}/${PATHS.DOCUMENTATION}`,
  ].includes(pathname);

  useEffect(() => {
    if (isStudentDisqualified && pathname !== `${url}/${PATHS.DASHBOARD}`) {
      historyPush(`${url}/${PATHS.DASHBOARD}`);
    }
  }, [historyPush, isStudentDisqualified, pathname, url]);

  useEffect(() => {
    if (
      isLoading || // isLoading
      pathname !== baseURL
    )
      return;

    if (shouldRedirectToWelcomeFlow === true) {
      historyPush(`${url}/${PATHS.WELCOME}`);
    } else if (shouldRedirectToWelcomeFlow === false) {
      historyPush(`${url}/${PATHS.DASHBOARD}`);
    }
  }, [
    baseURL,
    historyPush,
    isLoading,
    pathname,
    shouldRedirectToWelcomeFlow,
    url,
  ]);

  return {
    showGradient,
    scrollRef,
    isLoading:
      shouldRedirectToWelcomeFlow === null ||
      isAffordaPortalDetailsLoading ||
      isLoading,
  };
};

export default useAffordaPortal;
